import Base from './Base';

export default class Source extends Base {
    constructor(item) {
        super(item);

        if (item.billing_details) {
            this.brand = 'ach';
            this.email = item.billing_details.email;
            this.name = item.billing_details.name;
            this.phone = item.billing_details.phone;

            for (let key in item.billing_details.address) {
                this[`address_${key}`] = item.billing_details.address[key];
            }

            delete this.billing_details;
        }

        if (item.us_bank_account) {
            for (let key in item.us_bank_account) {
                this[key] = item.us_bank_account[key];
            }

            delete this.us_bank_account;
        }
    }

    get isTypeAch() {
        if (!this.networks) return false;

        return this.networks.preferred === 'ach';
    }
}
